// extracted by mini-css-extract-plugin
export default {"mobileGrid":"styles_mobileGrid__2F3ag"};